import axios from 'axios';
import Cookies from 'js-cookie';
const axiosInstance = axios.create({
  // baseURL: 'https://bask.addictaco.website/api',
  baseURL: 'https://app.baskeg.com/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'api-key': 'KpoKcXyjTCHxPquIyTLByode9ZioJ4NwRh4CAFwY5mgoOtw91iuda1Kh0duBaJkR',
    'Accept-Language': Cookies.get('i18nextLng') || 'en',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.log(error)
    return Promise.reject(error);
  }
);

export default axiosInstance;
